import './Inventory.css';

const vehicles = [
  {
    name: 'Subaru Outback XT',
    image: '/assets/images/subaru-outback.jpg',
    link: 'http://turo.com/us/en/suv-rental/united-states/truckee-ca/subaru/outback/3137777'
  },
  {
    name: 'Subaru Outback Touring XT',
    image: '/assets/images/subaru-outback-touring-xt.jpg',
    link: 'https://turo.com/us/en/suv-rental/united-states/truckee-ca/subaru/outback/3779179'
  },
  {
    name: 'Jeep Wrangler Unlimited',
    image: '/assets/images/jeep-wrangler.jpg',
    link: 'http://turo.com/us/en/suv-rental/united-states/truckee-ca/jeep/wrangler-unlimted/3348319'
  }
];

const Inventory = () => {
  return (
    <section id="inventory" className="section section-alt inventory">
      <div className="container">
        <h2 className="section-title">Inventory</h2>
        
        <div className="inventory-intro">
          <p>
            Right now, our cars are available through the peer-to-peer car share platform Turo - 
            but we're exploring direct rentals with perks like <strong>locals' discounts</strong> and{' '}
            <strong>special offers</strong>.
          </p>
          <p className="inventory-cta-text">
            Click a car below to view its availability on Turo.
          </p>
        </div>

        <div className="vehicles-grid">
          {vehicles.map((vehicle, index) => (
            <a 
              href={vehicle.link}
              key={index}
              className="vehicle-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="vehicle-image-container">
                <img 
                  src={vehicle.image} 
                  alt={vehicle.name}
                  className="vehicle-image"
                />
                <div className="vehicle-overlay">
                  <span className="view-on-turo">View on Turo →</span>
                </div>
              </div>
              <h3 className="vehicle-name">{vehicle.name}</h3>
            </a>
          ))}
        </div>

        <div className="signup-prompt">
          <p>
            Sign up below to be the first to know when direct rentals launch.
          </p>
          <a href="#signup" className="btn btn-outline">
            Join the List
          </a>
        </div>
      </div>
    </section>
  );
};

export default Inventory;
